module.exports = __webpack_public_path__ + "static/media/services-img3.2828bbbd.jpg";